var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
      'calendar-events-day': true,
      today: _vm.item.today === true,
      isDisabled: _vm.item.isDisabled === true,
      isHolidays: _vm.item.isHolidays
    }},[(_vm.item.isHolidays)?_c('tool-tip',{attrs:{"text":_vm.holidayText,"margin":"0","content-class":"top","position":{ top: 'top' }}},[_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")])]):_c('div',{staticClass:"date"},[_vm._v(" "+_vm._s(_vm.formattedDate)+" ")]),(_vm.item.users)?_c('div',{staticClass:"dots"},_vm._l((_vm.item.users),function(user,index){return _c('div',{key:index,staticClass:"dot"},[_c('span',{style:({ color: user.color })},[_vm._v("●")])])}),0):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }